import {type EventEmitter, type FunctionalComponent, h} from '@stencil/core';
import {downloadFile} from '../../../search-tab/tabular/utils';
import {ResultCardType} from '../../public/product-card/helpers/helpers';
import {GenericCardEventsLayer} from '../generic-card-event-layer/generic-card-event-layer';
import type {SearchProduct} from '../../../../../api/model/response/documents/public/Product';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';


export interface DialogFilesDownload {
    files: any; //eslint-disable-line @typescript-eslint/no-explicit-any
    labelProvider: labelProviderInterface;
    toggleDialog: CallableFunction;
    documentDownloadAnalytics: CallableFunction;
    isDialogOpen: boolean;
    clickEmitter: EventEmitter;
    index?: number;
}

export const DialogFilesDownload: FunctionalComponent<DialogFilesDownload> = (props) => {
    function generateDownloadPanel(files) {
        const linksList = files.attachments?.map((element) => {
            return {
              'url': element.url,
              'fileName': element.fileName,
              'extension': element.extension,
            };
        });

        function downloadSingleFile(file) {
            if (file.extension.toUpperCase() === 'PDF') {
              downloadFile(file.url, file.fileName);
            } else {
              const a = document.createElement('a');
              a.setAttribute('href', file.url);
              a.setAttribute('download', file.fileName);
              a.click();
            }
        }

        return <se-dialog
          color="alternative"
          size="large"
          page-scroll={false}
          onClick={(e) => {
              e.preventDefault();
              props.toggleDialog(false);
          }}
          padding={'small'}
          open={props.isDialogOpen}
        >
          <se-dialog-content
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
            }}
          >

            <p class={'dialog-title'}>{files.title?.replace(/(<([^>]+)>)/gi, '')}
              <a class={'dialog-close-button'} onClick={(e) => {
                  e.preventDefault();
                  props.toggleDialog(false);
              }}>
                <se-icon size={'small'}>action_close</se-icon>
              </a>
            </p>
            <p class={'dialog-product-id'}>{files.documentReference}</p>
            <div>
              <se-divider class={'dialog__divider'} option={'horizontal'} color={'standard'}/>
            </div>
            <p class={'dialog-files-title'}>
              {props.labelProvider('result.document.files-for-download', 'Files for download')}
            </p>
            <table>
              <tr>
                <th>{props.labelProvider('result.document.file-name', 'Filename')}</th>
                <th>{props.labelProvider('result.document.file-format', 'File format')}</th>
                <th></th>
              </tr>
              {files.attachments.map(element => {
                  return (<tr>
                    <td class={'dialog-table-file-name'}>{element.fileName.replace(`.${element.extension}`, '')}</td>
                    <td class={'dialog-table-extension'}>{element.extension.toUpperCase()}</td>
                    <td class={'dialog-table-link'}>
                      <GenericCardEventsLayer clickEmitter={props.clickEmitter}
                        resutCardType={ResultCardType.Document}
                        doc={props.files as unknown as SearchProduct} index={props.index}>
                        <qds-button importance="subdued" icon-name="arrow-down-tray" icon-library="default"
                          text={element.length} data-card-area={'background'}
                          href={element.url} onClick={(e) => {
                              props.documentDownloadAnalytics(
                                element.fileName,
                                files.f3Symbol || files.f2Symbol,
                                new URLSearchParams(element.url).get('p_Doc_Ref')
                              );
                              downloadSingleFile(element);
                          }}>
                        </qds-button>
                      </GenericCardEventsLayer>
                    </td>
                  </tr>);
              })}
              <tr class={'dialog-table-download-all'}>
                <td></td>
                <td></td>
                <td class={'dialog-table-download-all-files'}>
                  <GenericCardEventsLayer clickEmitter={props.clickEmitter}
                    resutCardType={ResultCardType.Document}
                    doc={props.files as unknown as SearchProduct} index={props.index}>
                    <qds-button importance="subdued" icon-name="arrow-down-tray" icon-library="default" data-card-area={'background'}
                      text={props.labelProvider('result.document.all-files', 'All files')}
                      href={'javascript: void(0)'} onClick={(e) => {
                          linksList.forEach((link, index) => {
                              setTimeout(() => {
                                  props.documentDownloadAnalytics(
                                    link?.name,
                                    files.f3Symbol || files.f2Symbol,
                                    new URLSearchParams(link?.url).get('p_Doc_Ref')
                                  );
                                  downloadSingleFile(link);
                              },
                              index * 500
                              );
                          });
                      }}>
                    </qds-button>
                  </GenericCardEventsLayer>
                </td>
              </tr>
            </table>
          </se-dialog-content>
        </se-dialog>;
    }
    return generateDownloadPanel(props.files);
};
